import cn from 'client/utils/cn';

import React, { Component } from 'react';

import './index.css';

const b = cn('chart');

interface Props {
    title: string;
    image: string;
    imageTablet?: string;
    imageDesktop?: string;
}

class Chart extends Component<Props> {
    render() {
        const { title, image, imageTablet, imageDesktop } = this.props;

        return (
            <div className={b('')}>
                <h3
                    className={b('title')}
                    dangerouslySetInnerHTML={{ __html: title }}
                    />

                <picture className={b('picture')}>
                    {imageDesktop && (
                        <source srcSet={imageDesktop} media="(min-width: 1279px)" />
                    )}

                    {imageTablet && (
                        <source srcSet={imageTablet} media="(min-width: 768px)" />
                    )}

                    <img src={image} className={b('image')} />
                </picture>
            </div>
        );
    }
}

export default Chart;
